<template>
  <div class="mifinity-page">
    <div v-if="token" id="mifinityWidget" class="mifinity-page__widget"></div>
    <div v-else class="mifinity-stub">
      <img src="./images/warning.png" class="mifinity-stub__image" />
      <h2 class="mifinity-stub__title">{{ $t('mifinity_page__stub_title') }}</h2>
      <p class="mifinity-stub__text">{{ $t('mifinity_page__stub_text') }}</p>
      <p class="mifinity-stub__text">{{ $t('mifinity_page__stub_contact_support_team') }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  mounted() {
    if (this.token) {
      this.initWidget();
    }
  },

  watch: {
    token(val) {
      if (val) this.initWidget();
    },
  },

  computed: {
    ...mapState(['paymentInvoiceData', 'flowData']),

    paymentInvoice() {
      return this.paymentInvoiceData ? this.paymentInvoiceData.data || this.paymentInvoiceData : {};
    },

    token() {
      const { credentials: { token = null } = {} } = this.flowData?.payload || {};

      return token;
    },
  },

  methods: {
    loadScript(url) {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${url}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = url;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    async initWidget() {
      const { id, test_mode } = this.paymentInvoice;
      const scriptUrl = test_mode
        ? 'https://demo.mifinity.com/widgets/sgpg.js?58190a411dc3'
        : 'https://secure.mifinity.com/widgets/sgpg.js?58190a411dc3';

      try {
        await this.loadScript(scriptUrl);
        const widget = window.showPaymentIframe('mifinityWidget', {
          token: this.token,
          complete: () => {
            widget.close();
            this.$router.push({
              name: 'PaymentStatus',
              params: { id },
            });
          },
        });
      } catch (error) {
        console.error('Failed to load Mifinity widget script', error);
      }
    },
  },
};
</script>
<style lang="scss">
.mifinity {
  &-page {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
  }

  &-stub {
    &__image {
      height: 100px;
    }

    &__title {
      margin: 0 0 5px;
    }

    &__text {
      margin: 0;
    }
  }
}
</style>
